import React, { memo, lazy, useMemo } from "react";
import { useSelector } from "react-redux";
// import GoogleCustomMap from "./GoogleCustomMap";
import GoogleCustomMap from "./GoogleCustomMap";
import Konsole from "../../utils/konsole/Konsole";
import { ReturnStoreAddress } from "../../utils/helper";
import { useTranslation } from "react-i18next";
import useStoreStatus from "../../hooks/useStoreStatus";
import { formatAddressTwoLines } from "../../utils/common/common.utils";
import LocationIcon from "../icons/LocationIcon";
import ClockIcon from "../icons/ClockIcon";

const AddressMap = () => {
  const { marketData } = useStoreStatus()
  const storeInfo = useSelector((state: any) => state?.store?.selectedStore);
  console.log("storeInfo", storeInfo);
  const { t } = useTranslation()


  const addressInfo = useMemo(() => {
    return formatAddressTwoLines(storeInfo?.address)
  }, [storeInfo?.address])

  return (
    <>
      {/* <div className="md:border shadow border-[#E6E6E6] flex lg:flex-row flex-col rounded-xl md:mb-6 mb-2 overflow-hidden mobile-map-hide">
        <div className="lg:w-4/5 w-full md:rounded-none rounded-xl overflow-hidden">
        <GoogleCustomMap/>
        </div>
        <div className="lg:w-1/5 w-full md:px-6 md:py-5 py-2 address-mob" >
          <p className="flex textMd font-normal gap-1 items-start mb-4">

            <img src="/images/location_svg.svg" className="textMd mt-1" />
            {ReturnStoreAddress(storeInfo)}
          </p>
          <p className="flex textMd gap-1 font-bold items-start">
            <img src="/images/timing_svg.svg" className="textMd" style={{marginTop:'3px'}} />
            {marketData?.pre ? (
              <>{t("MyAddress.closedOpensAt")} {marketData?.data?.from_time}</>
            ) : Object.keys(marketData)?.length !== 0 ? (
              <>{t("MyAddress.openUntil")} - {marketData?.data?.to_time}</>
            ) : (
              <>
                {t("MyAddress.closed")}
                {marketData?.data?.from_time ? ` Opens at ${marketData?.data?.from_time}` : null}
              </>
            )}
          </p>
        </div>

      </div> */}
      {/* shadow-sm */}
      <div className="
      border border-gray-200  
      flex lg:flex-row flex-col rounded-lg overflow-hidden bg-white items-stretch  mb-4 mobile-map-hide">

        {/* MAP */}
        <div className="lg:w-[75%] w-full h-[100px] lg:h-auto">
          <GoogleCustomMap />
        </div>

        {/* RIGHT PANEL */}
        <div className="lg:w-[25%] w-full px-6 py-2  flex flex-col justify-between h-full">

          {/* Address Section */}
          <div className="flex items-start gap-3">
               {/* <img src="/images/location_svg.svg" className="w-5 h-5 mt-1 opacity-70"/> */}
          
            <LocationIcon size={20} />
            <div className="space-y-1 ms-1" >
              <p className="custom-heding-style-2">{addressInfo?.line1}</p>
              <p className="custom-text-style-2">
                {addressInfo?.line2} {storeInfo?.postal_code}
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t my-2"></div>

          <div className="flex items-center gap-3">
            {/* <img src="/images/timing_svg.svg" className="w-3 h-3 " /> */}

            <ClockIcon size={12} />
            {/* <LocationIcon /> */}
            <p className="custom-heding-style-2 ms-1">
              {marketData?.pre ? (
                <>Opens at {marketData?.data?.from_time}</>
              ) : Object.keys(marketData || {}).length !== 0 ? (
                <>Open Until {marketData?.data?.to_time}</>
              ) : (
                <>Closed</>
              )}
            </p>
          </div>

        </div>
      </div>



    </>
  );
};

export default memo(AddressMap);



